import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconThumbDown.css';

const IconThumbDown = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
    >
      <g>
        <path
          d="M495.969,297.232l-24.695,14.225c-9.711,5.598-20.727,8.543-31.945,8.543H368c-8.836,0-16,7.164-16,16v132.16
     c0,15.375-12.469,27.84-27.844,27.84h-0.094c-11.977,0-22.617-7.668-26.406-19.035l-30.719-80.355
     c-7.117-18.611-19.844-34.547-36.422-45.598L160,304V64h14.273c11.602,0,22.977-3.152,32.93-9.121l49.594-29.758
     C266.75,19.152,278.125,16,289.727,16h136.938c13.852,0,27.32,4.492,38.398,12.801l34.141,25.6C507.258,60.443,512,69.928,512,80
     v189.504C512,280.947,505.891,291.52,495.969,297.232z"
        />
        <path
          d="M128,304V64c0-17.672-14.328-32-32-32H0v304h96C113.672,336,128,321.674,128,304z M96,96c0,17.672-14.328,32-32,32
		s-32-14.328-32-32s14.328-32,32-32S96,78.328,96,96z"
        />
      </g>
    </svg>
  );
};

IconThumbDown.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconThumbDown.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconThumbDown;
